import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  temporaryJobDetails: null,
  refreshDashboard: false,
};

const temporaryDashboard = createSlice({
  name: "temporaryDashboard",
  initialState: INITIAL_STATE,
  reducers: {
    setTemporaryJobDetails: (state, action) => {
      state.temporaryJobDetails = action.payload;
    },
    updateTemporaryJobDetails: (state, action) => {
      if (state.temporaryJobDetails?.id == action?.payload?.id) {
        state.temporaryJobDetails = action.payload;
      }
    },
    setRefreshDashboard: (state, action) => {
      state.refreshDashboard = action.payload;
    },
  },
});

export const {
  setTemporaryJobDetails,
  setRefreshDashboard,
  updateTemporaryJobDetails,
} = temporaryDashboard.actions;

export const temporaryDashboardReducer = temporaryDashboard?.reducer;
